import { memo, useCallback } from 'react';
import { useTranslation } from '@bonanza-social/i18n';
import { useNavigation, StackNavigationProp } from '@bonanza-social/navigation';
import { useSelector } from '@bonanza-social/toolkit/state';
import { selectStatus } from '../../state/status/status.slice';
import { openStatusProgressInfo } from '../../utils/status';
import { StatusDemotionProps } from './StatusDemotion.types';
import StatusDemotionAnimation from './StatusDemotionAnimation/StatusDemotionAnimation';
import StatusChange from '../StatusChange/StatusChange';

function StatusDemotion({ onButtonPress, ...rest }: StatusDemotionProps) {
  const [t] = useTranslation('status');
  const status = useSelector(selectStatus);
  const navigation =
    useNavigation<StackNavigationProp<AppNavigatorParamsList>>();
  const context = { context: status?.playerStatus };

  const renderAnimation = useCallback(
    (onAnimationEnd: () => void) =>
      status?.playerStatus && (
        <StatusDemotionAnimation
          playerStatus={status.playerStatus}
          onAnimationEnd={onAnimationEnd}
        />
      ),
    [status?.playerStatus],
  );

  const handleButtonPress = useCallback(() => {
    onButtonPress();

    if (!status) {
      return;
    }

    if (status.playerStatus === 'Member') {
      navigation.navigate('MainTabNavigator', { screen: 'Games' });

      return;
    }

    openStatusProgressInfo(status, navigation);
  }, [status, onButtonPress, navigation]);

  if (!status) {
    return;
  }

  return (
    <StatusChange
      overflow="hidden"
      heading={t('statusDemotionHeading', context)}
      subheading={t('statusDemotionSubheading', context)}
      description={t('statusDemotionDescription', context)}
      buttonText={t('statusDemotionButton', context)}
      renderAnimation={renderAnimation}
      onButtonPress={handleButtonPress}
      {...rest}
    />
  );
}

export default memo(StatusDemotion);
